import Resource from '@/plugins/sdk/Resource'
import { DATETIME, ITEM, STRING, UUID } from '@/plugins/sdk/fields'
import Profile from '../Profile'
import Team from '../Team'
import Ldap from '../User/Ldap'

export default class extends Resource {
  static name = 'enq_note'
  static label = 'enquiry_note'

  static get fields () {
    return {
      id: new UUID(),
      enq_type: new STRING(),
      enq_text: new STRING(),
      enq_public_reply: new STRING(),
      enq_date: new STRING(),
      profile: new ITEM(Profile),
      user: new ITEM(Ldap),
      team: new ITEM(Team),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
